<template>
    <b-modal :active.sync="isComponentModalActive"
             has-modal-card full-screen >

        <div class="modal-card ">
            <section class="modal-card-body"  >
                <b-loading  :active.sync="isFullScreenLoading" />

                <b-field grouped >
                  <b-field label="#" class="mr-5">
                    <template #label>
                      <span class="has-text-white">#</span>
                    </template>
                    <h1 class="has-text-grey-dark is-size-4">Web Log</h1>
                  </b-field>

                    <b-field label="Search" class="ml-3">
                        <b-datepicker v-model="date_selected"
                                      placeholder="Click to select..."
                                      icon="calendar-today">
                        </b-datepicker>
                    </b-field>
                    <b-field label="Search">
                        <b-button type="is-success" icon-left="magnify"  outlined @click="searchWebLog"    ref="btnSearch"  ></b-button>
                    </b-field>


                </b-field>

                <b-table
                        :data="isEmpty ? [] : dataWebLogCompute"
                        bordered
                        striped
                        narrowed
                        hoverable
                        focusable
                        mobile-cards
                        paginated
                        :per-page="perPage"
                        :current-page.sync="currentPage"
                        >


                        <b-table-column  label="ID"  :visible=false v-slot="props">
                            {{ props.row.id }}
                        </b-table-column>
                        <b-table-column  label="User"  v-slot="props">
                            {{ props.row.user }}
                        </b-table-column>
                        <b-table-column  label="Actions"  v-slot="props">
                            {{ props.row.action }}
                        </b-table-column>
                        <b-table-column  label="Detail"  v-slot="props" >
                            {{ props.row.detail }}
                        </b-table-column>
                        <b-table-column  label="Date/Time"  v-slot="props" >
                            {{ props.row.datatime_rec }}
                        </b-table-column>


                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon
                                            icon="emoticon-sad"
                                            size="is-large">
                                    </b-icon>
                                </p>
                                <p>Nothing here.</p>
                            </div>
                        </section>
                    </template>
                </b-table>



            </section>
            <footer class="modal-card-foot">
                <b-button size="is-medium" type="is-danger"
                          icon-left="close" @click="closeModalWebLog">
                    Close
                </b-button>
            </footer>
        </div>

    </b-modal>
</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios";
    import {getConfigAxios , getBaseURLforBackEnd  }  from '@/utils.js'
    // import moment from "moment";
    import { mapState } from "vuex";



    export default {
        name: "WebLog",
        computed:{
            ...mapState({
              access_token : state => state.master_data.access_token,
            }),



            dataWebLogCompute:function () {
               return this.dataWebLog.map((dat) =>{
                   // console.log(typeof dat.detail
                       if(typeof dat.detail === "object"){
                           const tmp =  dat.detail.type == 1 ?
                               `ชนิด 1 คำค้น ${dat.detail.dat_type1.idopd}  ${dat.detail.dat_type1.owner}   ${dat.detail.dat_type1.ownersurname}   ${dat.detail.dat_type1.opdname} `:
                               `ชนิด 2 คำค้น ${dat.detail.dat_type2.homeaddress} `
                           dat.detail = tmp
                       }
                     return dat
                    })
            }
        },
        data(){
            return {
                isComponentModalActive : false,
                isFullScreenLoading: false,
                date_selected : null,
                dataWebLog : [],
                isEmpty : false,
                perPage : 50 ,
                currentPage : 1
            }
        },
        methods:{
            searchWebLog(){

              const d = this.date_selected;
              // ดึง "ปี-เดือน-วัน" จากโซนเวลา browser (Asia/Bangkok)
              const year  = d.getFullYear();
              const month = String(d.getMonth() + 1).padStart(2, '0');
              const day   = String(d.getDate()).padStart(2, '0');


                const datTo = {
                    "date_selected" : `${year}-${month}-${day}T00:00:00.000Z`
                }
              // console.log(JSON.stringify(datTo));
                const vm = this
                this.isFullScreenLoading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listweblog`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                            vm.$buefy.toast.open({
                                message: `Success loading`,
                                type: 'is-success'
                            })
                            vm.dataWebLog  =  res.data
                            vm.isFullScreenLoading = false
                        }
                    })
                    .catch((err)=>{
                          const backendMsg = err.response?.data?.msg ?? err.message;
                          this.$buefy.dialog.alert({
                            title: 'Error',
                            message: backendMsg,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                          })
                          vm.isFullScreenLoading = false
                        // vm.isFullScreenLoading = false;
                        // this.$buefy.dialog.alert({
                        //     title: 'Error',
                        //     message: `${err}`,
                        //     type: 'is-danger',
                        //     hasIcon: true,
                        //     icon: 'times-circle',
                        //     iconPack: 'fa',
                        //     ariaRole: 'alertdialog',
                        //     ariaModal: true
                        // })
                    })
                    .finally(()=>
                        vm.isFullScreenLoading = false
                    )
            },
            closeModalWebLog(){
                this.$emit("closeModalWebLog")
            },
            loadCurrentDate(){
                axios.get(`${getBaseURLforBackEnd()}/api/curdatetime` ,getConfigAxios())
                    .then( response => {
                        this.date_selected = new Date( response.data.current_datetime)
                    })

            }
        }
    }
</script>

<style scoped>

</style>